import http from '@/request/index'
export default {
  namespaced: true,
  state: {
    resultData: null,
    id: 0, //cna结果id
    menuData: null, //菜谱数据
    scienceFoodAttr: [] //食物类型数组
  },
  getters: {},
  actions: {
    getMenuData(context) {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await http.getBaseApp('que/CnaV2/getMenuData', {
            cna_new_id: context.state.id
          })
          if (res.data.code == 200) {
            let menuData = dealData(res.data.data)
            let scienceFoodAttr = res.data.data.scienceFoodAttr
            context.commit('setMenuData', menuData)
            context.commit('setScienceFoodAttr', scienceFoodAttr)
          }
          resolve(res.data)
        } catch (error) {
          reject()
        }
      })
    }
  },
  mutations: {
    setResultData(state, b) {
      state.resultData = b
    },
    setQueId(state, b) {
      state.id = b
    },
    setMenuData(state, b) {
      state.menuData = b
    },
    setScienceFoodAttr(state, b) {
      state.scienceFoodAttr = b
    }
  }
}

function dealData(list) {
  list.selfControl.map((dayitem, dayindex) => {
    dayitem.data.map((mealitem, mealindex) => {
      if (!mealitem.meal_data) {
        mealitem.meal_data = []
      }
      mealitem.meal_data = mealitem.meal_data.filter((typeitem) => {
        typeitem.data = typeitem.data.filter((fooditem) => {
          return fooditem
        })
        return typeitem.data.length
      })
    })
  })
  /* 将外卖中的food_attr_ids的id数组处理成文字 */
  let foodTypeObj = {}
  list.scienceFoodAttr.map((item) => {
    foodTypeObj[item.id] = item
  })
  list.takeAway.map((dayitem, dayindex) => {
    dayitem.data.map((mealitem, mealindex) => {
      mealitem.meal_data.food_list.map((fooditem) => {
        if (fooditem.food_attr_ids && fooditem.food_attr_ids.length) {
          let attrName = ''
          fooditem.food_attr_ids.map((attrItem, attrIndex) => {
            if (attrIndex < fooditem.food_attr_ids.length - 1) {
              attrName = attrName + foodTypeObj[attrItem].name + '+'
            } else {
              attrName = attrName + foodTypeObj[attrItem].name
            }
          })
          fooditem.attr_name = attrName
        }
      })
    })
  })
  let res = [
    {
      title: '自制版',
      data: list.selfControl || []
    },
    {
      title: '外卖版',
      data: list.takeAway || []
    }
  ]
  return res
}
